export default __webpack_public_path__ + "static/media/CarWrappingPageLocation.205f5766.jpg";